<template>
  <div class="main scroll">
    <div slot="top">
      <p class="report-title">
        衡水市{{ dimension.stageName }}学生综合素质评价学期报告
      </p>
      <p class="report-title-sub">
        <span>学校：<span class="info-text"></span></span>
        <span>班级： <span class="info-text"></span></span>
        <span>第<span class="info-text"></span>学期</span>
        <span><span class="info-text"></span>学年</span>
      </p>
    </div>
    <page-template :card-list="cards" :title-show="false"> </page-template>
  </div>
</template>
<script>
import PageTemplate from './components/PageTemplate'
import StatusCard from './components/StatusCard/components/StatusCard'
const defaultImg =
  'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAYAAAD+4+QTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAApSURBVEhL7c0xAQAADIOw+TfNNPD0IgZyDJQoJUqJUqKUKCVKiTJI4AEA7PN9EAZFUQAAAABJRU5ErkJggg=='
export default {
  name: 'quality-evaluation-term-report',
  data: function() {
    return {
      cards: {
        baseInfo: {}
      },
      firstLoading: true, // 判断是否首次加载，首次加载按序调用接口
      titleInfo: {}
    }
  },
  methods: {
    getTitleInfo(data) {
      const {
        cityName,
        countyName,
        schoolName,
        className,
        schoolYearName,
        schoolTermName
      } = data
      Object.assign(this.titleInfo, {
        cityName,
        countyName,
        schoolName,
        className,
        schoolYearName,
        schoolTermName
      })
    },
    getBaseInfo(resolve, reject) {
      const indicators = [
        '思想品德',
        '学业水平',
        '身心健康',
        '艺术素养',
        '社会实践',
        '奖励情况',
        '综合性评语'
      ]
      let _this = this
      const lineBuilder = function() {
        const arr = [
          [
            {
              value: '姓名',
              style: {
                width: '128px'
              }
            },
            {
              type: 'textedit',
              x: 2,
              style: {
                width: '194px'
              }
            },
            {
              value: '性别',
              style: {
                width: '128px'
              }
            },
            {
              type: 'textedit',
              x: 2,
              style: {
                width: '189px'
              }
            },
            {
              value: '班级',
              style: {
                width: '128px'
              }
            },
            {
              type: 'textedit',
              style: {
                width: '226px'
              }
            }
          ],
          [
            {
              value: '学籍号'
            },
            {
              type: 'textedit',
              x: 7
            }
          ],
          [
            {
              value: '身份证号'
            },
            {
              type: 'textedit',
              x: 7
            }
          ],
          [
            {
              value: '综合素质评价',
              x: 8
            }
          ]
        ]
        indicators.forEach((ind, i) => {
          switch (i) {
            case 0:
              arr.push(
                [
                  {
                    value: ind,
                    y: 2,
                    style: {
                      width: '128px'
                    }
                  },
                  {
                    value: '成绩',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    value: '备注',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ],
                [
                  {
                    type: 'textedit',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    type: 'textedit',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ]
              )
              break
            case 1:
              break
            case 3:
              arr.push(
                [
                  {
                    value: ind,
                    y: 3
                  },
                  {
                    value: '科目',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    value: '成绩',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ],
                [
                  {
                    value: '音乐',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    type: 'textedit',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ],
                [
                  {
                    value: '美术',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    type: 'textedit',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ]
              )
              break
            case 5:
            case 6:
              arr.push([
                {
                  value: ind,
                  y: 1,
                  style: {
                    height: i === 5 ? '150px' : '200px'
                  }
                },
                {
                  type: 'gridarea',
                  x: 7,
                  style: {
                    width: '434px'
                  }
                }
              ])
              break
            default:
              arr.push(
                [
                  {
                    value: ind,
                    y: 2
                  },
                  {
                    value: '成绩',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    value: '备注',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ],
                [
                  {
                    type: 'textedit',
                    x: 4,
                    style: {
                      width: '434px'
                    }
                  },
                  {
                    value: '',
                    x: 3,
                    style: {
                      width: '434px'
                    }
                  }
                ]
              )
              break
          }
        })
        arr.push([
          {
            value: '班主任（签章）',
            style: {
              height: '128px',
              width: '128px',
              padding: '0 20px'
            }
          },
          {
            type: 'imageshow',
            value: defaultImg,
            x: 3,
            style: {
              height: '128px',
              width: '369.5px'
            }
          },
          {
            value: '学校负责人（签章）',
            x: 2,
            style: {
              height: '128px',
              width: '128px',
              padding: '0 10px'
            }
          },
          {
            type: 'imageshow',
            value: defaultImg,
            x: 2,
            style: {
              height: '128px',
              width: '369.5px'
            }
          }
        ])
        // 学业水平
        let subjectItemList = []
        if (
          _this.dimension.indicatorsItemList &&
          _this.dimension.indicatorsItemList.length > 0
        ) {
          subjectItemList = _this.dimension.indicatorsItemList.map(row => {
            return {
              subjectName: row.indicatorsName,
              subjectScore: null
            }
          })
        }
        const list = [
          [
            {
              value: '学业水平',
              y: 9
            },
            {
              value: '科目',
              style: {
                width: '130px'
              }
            },
            {
              value: '成绩',
              x: 3,
              style: {
                width: '303px'
              }
            },
            {
              value: '科目',
              style: {
                width: '130px'
              }
            },
            {
              value: '成绩',
              x: 2,
              style: {
                width: '303px'
              }
            }
          ]
        ]
        for (let i = 0; i < 8; i++) {
          list.push([
            {
              value: '',
              style: {
                width: '130px'
              }
            },
            {
              type: 'textedit',
              x: 3,
              value: '',
              style: {
                width: '303px'
              }
            },
            {
              value: '',
              style: {
                width: '130px'
              }
            },
            {
              type: 'textedit',
              x: 2,
              value: '',
              style: {
                width: '303px'
              }
            }
          ])
        }
        for (let i = 0; i < subjectItemList.length; i++) {
          const item = subjectItemList[i]
          if (i < 8) {
            const subject = list[1 + i]
            subject[0].value = item.subjectName
            subject[1].value = item.subjectScore
          } else {
            const subject = list[i - 7]
            subject[2].value = item.subjectName
            subject[3].value = item.subjectScore
          }
        }
        arr.splice(6, 0, ...list)
        return arr
      }
      const setData = function(arr, data) {
        const { subjectItemList } = data
        const list = [
          [
            {
              value: '学业水平',
              y: 9
            },
            {
              value: '科目',
              style: {
                width: '130px'
              }
            },
            {
              value: '成绩',
              x: 3,
              style: {
                width: '303px'
              }
            },
            {
              value: '科目',
              style: {
                width: '130px'
              }
            },
            {
              value: '成绩',
              x: 2,
              style: {
                width: '303px'
              }
            }
          ]
        ]
        for (let i = 0; i < 8; i++) {
          list.push([
            {
              value: '',
              style: {
                width: '130px'
              }
            },
            {
              type: 'textedit',
              x: 3,
              value: '',
              style: {
                width: '303px'
              }
            },
            {
              value: '',
              style: {
                width: '130px'
              }
            },
            {
              type: 'textedit',
              x: 2,
              value: '',
              style: {
                width: '303px'
              }
            }
          ])
        }
        for (let i = 0; i < subjectItemList.length; i++) {
          const item = subjectItemList[i]
          if (i < 8) {
            const subject = list[1 + i]
            subject[0].value = item.subjectName
            subject[1].value = item.subjectScore
          } else {
            const subject = list[i - 7]
            subject[2].value = item.subjectName
            subject[3].value = item.subjectScore
          }
        }
        arr.splice(6, 0, ...list)
        const indexlist = [
          [0, 1, 'studentName'],
          [0, 3, 'gender'],
          [0, 5, 'className'],
          [1, 1, 'studentNumber'],
          [2, 1, 'idCard'],
          [5, 0, 'moralScore'],
          [5 + list.length + 2, 0, 'constitutionScore'],
          [5 + list.length + 4, 1, 'artMusicScore'],
          [5 + list.length + 5, 1, 'artFineScore'],
          [5 + list.length + 7, 0, 'practiceScore'],
          [5 + list.length + 8, 1, 'rewardsContent'],
          [5 + list.length + 9, 1, 'evalTeacher']
        ]
        indexlist.forEach(index => {
          arr[index[0]][index[1]].value = data[index[2]]
        })
        return arr
      }
      // const xhrPut = this.$xhrPut
      const updateHttpData = async function() {
        return true
      }
      this.cardTemplate(
        'baseInfo',
        null,
        '/eval/evaluation/report/term/teacher',
        {
          schoolTermId: this.student.schoolTermId,
          studentId: this.student.studentId
        },
        lineBuilder,
        setData,
        updateHttpData,
        false
      )
        .then(resolve)
        .catch(reject)
    },
    // 阻塞函数，确保回调函数执行完成后，阻塞指定时间再向下运行
    fnPromise(fn, milliseconds = 1000) {
      return new Promise((resolve, reject) => {
        const fnResolve = () => {
          setTimeout(resolve, milliseconds)
        }
        fn(fnResolve, reject)
      })
    },
    /**
     * @function 生成页面学籍卡通用接口
     */
    async cardTemplate(
      cardName,
      title,
      url,
      params,
      lineBuilder,
      setData,
      updateHttpData,
      canEdit
    ) {
      let arr = lineBuilder()
      // 学籍卡未生成，创建学籍卡对象并配置
      this.$set(
        this.cards,
        cardName,
        new StatusCard(arr, title, null, updateHttpData, canEdit)
      )
      return true
    }
  },
  watch: {
    student: {
      async handler(newVal) {
        if (newVal) {
          if (this.firstLoading) {
            await this.fnPromise(this.getBaseInfo, 1)
            this.firstLoading = false
          } else {
            this.fnPromise(this.getBaseInfo, 1)
          }
        }
      },
      // immediate: true,
      deep: true
    }
  },
  props: {
    student: {
      type: Object,
      default: null
    },
    dimension: {
      type: Object
    }
  },
  components: {
    PageTemplate
  }
}
</script>
<style lang="scss" scoped>
.main {
  height: 100%;
  overflow-y: auto;
}
.report-title,
.report-title-sub {
  margin: 0 auto;
  padding: 10px 0;
  width: 1000px;
  font-family: 宋体;
}
.report-title {
  font-size: 28px;
  padding: 15px;
  font-weight: bold;
  text-align: center;
}
.report-title-sub {
  font-size: 18px;
  height: 18px;
  & > span:nth-child(1),
  & > span:nth-child(2) {
    margin-right: 10px;
    float: left;
  }
  & > span:nth-child(3),
  & > span:nth-child(4) {
    margin-left: 10px;
    float: right;
  }
  .info-text {
    display: inline-block;
    width: max-content;
    padding: 0 20px;
    border: 1px solid #9b9b9b;
    border-width: 0 0 1px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/QualityEvaluationTermReportStatic.vue